import React from "react";

import { Icon } from "../../../../Icon";
import { ButtonCell } from "../../../ButtonCell";
import { createDisplayNameForButtonCellActionElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCellActionElement } from "../../utils/getTestId";

import classes from "../../ButtonCellAction.styl";

const RIGHT_ICON_TEST_ID = createTestIdForButtonCellActionElement("right-icon");

const BUTTON_CELL_ACTION_RIGHT_ADDON_TEST_ID =
    createTestIdForButtonCellActionElement("right-addon");

export const ButtonCellActionRightAddon = () => {
    return (
        <ButtonCell.RightAddon
            data-tsid={BUTTON_CELL_ACTION_RIGHT_ADDON_TEST_ID}
        >
            <Icon
                size="24"
                data-tsid={RIGHT_ICON_TEST_ID}
                icon="glyph_done_24+"
                className={classes.icon}
            />
        </ButtonCell.RightAddon>
    );
};

ButtonCellActionRightAddon.displayName =
    createDisplayNameForButtonCellActionElement("RightAddon");

export default ButtonCellActionRightAddon;
